/*
 * @Author: wuhao
 * @Date: 2020-04-08 14:28:17
 * @LastEditors: wuhao
 * @LastEditTime: 2020-04-08 14:30:59
 * @Description: Link 文字链接
 */

import ApexLink from './src/index'

ApexLink.install = function(Vue) {
  Vue.component(ApexLink.name, ApexLink)
}

export default ApexLink
